(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const inquiryParameters = new URLSearchParams(window.location.search);
  if (inquiryParameters.get('inquiry') === 'wholesale-product') {
    const productName = inquiryParameters.get('product') || 'Wholesale product';
    const inquiryType = document.querySelector('[data-wholesale-inquiry-type]');
    const inquiryProduct = document.querySelector('[data-wholesale-inquiry-product]');
    const inquiryNotice = document.querySelector('[data-wholesale-inquiry-notice]');
    const inquiryProductName = document.querySelector('[data-wholesale-inquiry-product-name]');
    const message = document.querySelector('#ContactForm-body');

    if (inquiryType) inquiryType.value = 'Wholesale product inquiry';
    if (inquiryProduct) inquiryProduct.value = productName;
    if (inquiryProductName) inquiryProductName.textContent = productName;
    if (inquiryNotice) inquiryNotice.hidden = false;
    if (message && !message.value.trim()) message.value = `I am interested in wholesale information for ${productName}.`;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osm-sales-order-request"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-osm-sales-search]').forEach((input)=>{input.addEventListener('input',()=>{const term=input.value.trim().toLowerCase();document.querySelectorAll('[data-osm-sales-products] [data-search]').forEach((row)=>{row.hidden=term!==''&&!row.dataset.search.toLowerCase().includes(term);});});});
document.querySelectorAll('#OSMSalesOrderRequest').forEach((form)=>{const selector=form.querySelector('[data-client-selector]');const payment=form.querySelector('[data-payment-method]');const terms=form.querySelector('[data-client-terms]');const fields={business:form.querySelector('[data-client-business]'),contact:form.querySelector('[data-client-contact]'),email:form.querySelector('[data-client-email]'),cell:form.querySelector('[data-client-cell]'),phone:form.querySelector('[data-client-phone]'),address:form.querySelector('[data-client-address]')};const key='osm-sales-clients-'+(form.dataset.salespersonEmail||'salesperson').toLowerCase();let central=[];let saved=[];try{central=JSON.parse(form.querySelector('[data-assigned-clients]').textContent||'[]')||[];}catch(error){central=[];}try{saved=JSON.parse(localStorage.getItem(key)||'[]')||[];}catch(error){saved=[];}const clients=[...central,...saved].filter((client,index,list)=>client&&client.business&&list.findIndex((item)=>String(item.email||item.business).toLowerCase()===String(client.email||client.business).toLowerCase())===index).sort((a,b)=>a.business.localeCompare(b.business));clients.forEach((client,index)=>{const option=document.createElement('option');option.value=String(index);option.textContent=client.business+(client.contact?' — '+client.contact:'');selector.append(option);});selector.addEventListener('change',()=>{const client=selector.value===''?null:clients[Number(selector.value)];Object.keys(fields).forEach((name)=>{fields[name].value=client&&client[name]?client[name]:'';});const savedTerms=client&&client.terms?client.terms:'Not applicable';payment.value=savedTerms==='Not applicable'?'Pay now':'Net terms - approved client';terms.value=savedTerms;payment.dispatchEvent(new Event('change'));});form.addEventListener('submit',()=>{const client={business:fields.business.value.trim(),contact:fields.contact.value.trim(),email:fields.email.value.trim(),cell:fields.cell.value.trim(),phone:fields.phone.value.trim(),address:fields.address.value.trim(),terms:payment.value.startsWith('Net terms')?terms.value:'Not applicable'};if(!client.business||!client.email)return;const next=saved.filter((item)=>String(item.email||'').toLowerCase()!==client.email.toLowerCase());next.push(client);localStorage.setItem(key,JSON.stringify(next));});});
document.querySelectorAll('#OSMSalesOrderRequest').forEach((form)=>{const payment=form.querySelector('[data-payment-method]');const submit=form.querySelector('[data-sales-submit]');const note=form.querySelector('[data-payment-note]');const inventoryStatus=form.querySelector('[data-inventory-status]');const quantityInputs=[...form.querySelectorAll('[data-variant-id]')];const hasOverage=()=>quantityInputs.some((input)=>Number(input.value)>Number(input.dataset.available||0)&&input.dataset.specialOrder!=='true');const updateMode=()=>{const net=payment.value.startsWith('Net terms');const over=hasOverage();submit.textContent=net?'Submit Net Terms request for approval':over?'Submit order for production review':'Proceed to secure payment';note.textContent=net?'Net Terms orders require Old Salty Mill approval before an invoice is issued.':over?'This salesperson order exceeds available stock and will be submitted for production and fulfillment review.':'Every item is in stock. This pay-now order is approved automatically and proceeds directly to secure checkout.';inventoryStatus.value=over?'Quantity exceeds available stock — production review required':'Within available inventory';};payment.addEventListener('change',updateMode);quantityInputs.forEach((input)=>input.addEventListener('input',updateMode));updateMode();form.addEventListener('submit',async(event)=>{const items=quantityInputs.map((input)=>({id:Number(input.dataset.variantId),quantity:Number(input.value)})).filter((item)=>item.quantity>0);if(items.length===0){event.preventDefault();window.alert('Enter a quantity for at least one product.');return;}if(payment.value.startsWith('Net terms')||hasOverage())return;event.preventDefault();if(!form.reportValidity())return;submit.disabled=true;submit.textContent='Preparing secure checkout…';const root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';const attributes={'Salesperson name':form.dataset.salespersonName||'','Salesperson email':form.dataset.salespersonEmail||'','Client business':form.querySelector('[data-client-business]').value,'Client contact':form.querySelector('[data-client-contact]').value,'Client email':form.querySelector('[data-client-email]').value,'Payment route':'Credit card — paid at checkout','Approval status':'Automatically approved — inventory available'};try{await fetch(root+'cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}});const added=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!added.ok)throw new Error('One or more products could not be added to the order.');const updated=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes})});if(!updated.ok)throw new Error('The salesperson and client details could not be attached to the order.');window.location.assign(root+'checkout');}catch(error){window.alert(error.message||'The order could not be prepared. Please try again.');submit.disabled=false;updateMode();}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osm-wholesale-portal"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-osm-product-search]').forEach((input)=>{input.addEventListener('input',()=>{const term=input.value.trim().toLowerCase();document.querySelectorAll('[data-osm-product-grid] [data-title]').forEach((card)=>{card.hidden=term!==''&&!card.dataset.title.toLowerCase().includes(term);});});});document.querySelectorAll('[data-client-available]').forEach((input)=>{input.addEventListener('input',()=>{const available=Number(input.dataset.clientAvailable||0);if(Number(input.value)>available){input.value=String(available);input.setCustomValidity('Wholesale clients cannot order more than the available quantity.');input.reportValidity();}else{input.setCustomValidity('');}});});

  } catch(e) { console.error(e); }
})();
})();
